import React from 'react';
import AddEditUserForm from 'ui-component/AddEditUserForm';

function AddUser() {
  return (
    <div>
      <AddEditUserForm title="Add Admin User" />
    </div>
  );
}

export default AddUser;
